import React from 'react';
export const FilledFolderGreyed = () => (
  <svg width="114px" height="116px" viewBox="0 0 114 116" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-566.000000, -2074.000000)">
        <g transform="translate(566.000000, 2074.000000)">
          <polygon
            fill="#F3F4F6"
            points="81.1534 79.142 31.1684 87.724 26.7784 49.071 44.1654 46.085 44.6244 49.134 76.5504 43.653"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.1534 79.142 31.1684 87.724 26.7784 49.071 44.1654 46.085 44.6244 49.134 76.5504 43.653"
          />
          <g transform="translate(53.000000, 23.710000)">
            <polyline
              fill="#FCFCFC"
              points="3.1123 10.8881 4.3443 0.5641 32.5413 3.9301 28.3513 39.0231 0.1553 35.6571 2.4903 16.0971"
            />
            <polyline
              stroke="#C3D3D8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="3.1123 10.8881 4.3443 0.5641 32.5413 3.9301 28.3513 39.0231 0.1553 35.6571 2.4903 16.0971"
            />
          </g>
          <path
            d="M60.251,38.0434 L78.619,40.2364"
            stroke="#E2E8EE"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M61.0191,31.6108 L67.1501,32.3428"
            stroke="#E2E8EE"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M59.7432,42.2963 L78.1112,44.4893"
            stroke="#E2E8EE"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M59.2119,46.7465 L77.5799,48.9385"
            stroke="#E2E8EE"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M58.6905,51.1156 L67.4145,52.1576"
            stroke="#E2E8EE"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M77.7617,26.7113 L77.8137,26.2763 C77.9227,25.3643 78.7227,24.7023 79.5917,24.8063 C80.4607,24.9103 81.0827,25.7413 80.9737,26.6533 L80.5677,30.0523 C80.4587,30.9643 79.6587,31.6253 78.7897,31.5223 C77.9207,31.4183 77.2997,30.5873 77.4077,29.6753"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FCFCFC"
            points="62.5703 61.0815 41.9813 65.3945 36.6813 40.1005 52.4193 36.8035 58.1473 40.7335"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="62.5703 61.0815 41.9813 65.3945 36.6813 40.1005 52.4193 36.8035 58.1473 40.7335"
          />
          <g transform="translate(22.000000, 48.710000)">
            <polyline
              fill="#FCFCFC"
              points="2.9634 18.1801 0.3674 9.4641 52.0154 0.5961 59.1534 30.4321 9.1684 39.0141 4.4214 23.0781"
            />
            <polyline
              stroke="#C3D3D8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="2.9634 18.1801 0.3674 9.4641 52.0154 0.5961 59.1534 30.4321 9.1684 39.0141 4.4214 23.0781"
            />
          </g>
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="52.3438 37.0736 53.4218 41.7906 58.0778 40.7556"
          />
          <path
            d="M24.2129,0.5326 L24.2129,2.9146"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M24.2129,7.6781 L24.2129,10.0601"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M28.9766,5.2963 L26.5946,5.2963"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M21.8311,5.2963 L19.4491,5.2963"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M102.4312,37.018 L102.4312,39.4"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M102.4312,44.1635 L102.4312,46.5455"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M107.1949,41.7817 L104.8129,41.7817"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M100.0493,41.7817 L97.6673,41.7817"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M112.8868,26.0961 C112.8868,27.0941 112.0768,27.9041 111.0788,27.9041 C110.0808,27.9041 109.2708,27.0941 109.2708,26.0961 C109.2708,25.0971 110.0808,24.2881 111.0788,24.2881 C112.0768,24.2881 112.8868,25.0971 112.8868,26.0961 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M39.0703,14.8246 C39.0703,15.8226 38.2613,16.6326 37.2623,16.6326 C36.2643,16.6326 35.4553,15.8226 35.4553,14.8246 C35.4553,13.8256 36.2643,13.0156 37.2623,13.0156 C38.2613,13.0156 39.0703,13.8256 39.0703,14.8246 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M20.0855,72.2963 L18.7495,72.9793"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="17.0767 73.8334 15.7407 74.5154 15.0587 73.1794"
          />
          <path
            d="M12.5884,68.3412 L2.7064,48.9892"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.716,5.432"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="1.4712 46.5707 0.7882 45.2347 2.1242 44.5527"
          />
          <path
            d="M6.7959,42.1674 L18.4739,36.2044"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.623,5.245"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="20.8101 35.0111 22.1461 34.3291 22.8281 35.6651"
          />
          <path
            d="M25.9473,41.7738 L26.6293,43.1098"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.1568,110.4926 C71.1568,113.1186 63.6988,115.2476 54.5008,115.2476 C45.3018,115.2476 37.8438,113.1186 37.8438,110.4926 C37.8438,107.8656 45.3018,105.7366 54.5008,105.7366 C63.6988,105.7366 71.1568,107.8656 71.1568,110.4926"
            fill="#F3F4F6"
          />
        </g>
      </g>
    </g>
  </svg>
);
